import { OperationListColumns } from 'src/types/ViewModel/Stowage/OperationListColumns';

export const INITIAL_OPERATION_LIST_COLUMNS: OperationListColumns = {
    showTradeName: true,
    showProductName: false,
    showCharterer: false,
    showContractWeight: false,
    showNominatedWeight: true,
    showTotalCargoNominatedWeight: false,
    showBillOfLadingFigure: false,
    showShipFigure: false,
    showSwingWeights: false,
    showSwingVolumes: false,
    showNominatedVolume: true,
    showStowedWeight: true,
    showStowedVolume: true,
    showNotStowedWeight: true,
    showNotStowedVolume: true,
    showOption: true,
    showLitreWeight: true,
    showPorts: true,
    showUscgGroupNumber: false,
    showPollution: false,
    showShipType: false,
    showHeating: false,
    showMaxAdjacentTemp: false,
    showFlashPoint: false,
    showMeltingPoint: false,
    showBoilingPoint: false,
    showSource: false,
    showContractStatus: false,
    showTankNames: false,
};
